<template>
  <div>
    <DynamicComponent
      edc-id="polaris-athena"
      framework="React"
      :edc-dev="edcDev"
      :edcCache="edcDev"
      runtime-did-mounted="{runtimeDidMounted}"
      :edcQuery="{ abRate, mis }"
    />
  </div>
</template>

<script>
export default {
  name: 'Athena',
  data() {
    const { abRate, mis } = window.__EDC__.options.extendEnvKeys
    return {
      edcDev: window.__EDC__.options.dev,
      abRate,
      mis,
    }
  },
  methods: {
    runtimeDidMounted(context) {
      console.log('runtimeDidMounted context', context)
    },
  },
}
</script>
